module.exports = __webpack_public_path__ + "static/media/example-resume.24c7119d.jpg";